import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import axios from "axios";

import { onClickLogout } from "../../../store/user";
import { useModal } from "../../../hooks/useModal";
import useUserAuthActions from "../../../hooks/useUserStorage.jsx";

import ShopSideMenu from "./component/shopSideMenu";
import SlidingSideMenu from "./component/slidingSideMenu";
import Logo from "./component/common/logo";
import Gnb from "./component/common/gnb";
import Tnb from "./component/common/tnb";
import Search from "./component/common/search";
import SearchForm from "./component/common/searchForm";
import Category from "./component/common/category";

import { HeaderContainer } from "./component/styled/header";

const ShoppingHeader = ({ url, homepageInfo, theme, isMatch, menus }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const path = location?.state?.path || "";

  const user = useSelector((state) => state?.user?.data[0]);
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });

  const { modal, openModal, closeModal } = useModal();
  const { handleLogout: userAuthLogout } = useUserAuthActions();

  const [cmpnyNm, setCmpnyNm] = useState("");
  const [logo, setLogo] = useState("");
  const [clickSideMenu, setClickSideMenu] = useState(false);
  const [toggleSearch, setToggleSearch] = useState(false);

  useEffect(() => {
    if (homepageInfo) {
      setCmpnyNm(homepageInfo?.logoText || homepageInfo?.cmpnyNm);
      setLogo(imgHandler(homepageInfo.logoImage));
    }
  }, [homepageInfo]);

  useEffect(() => {
    if (!toggleSearch) return;

    const handleScroll = () => {
      if (window.scrollY > 195) {
        setToggleSearch(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [toggleSearch]);

  const handleHome = () => {
    navigate(`/shop${url ? `/${url}` : ""}`);
  };

  const handleLogoutModal = () => {
    if (clickSideMenu) setClickSideMenu(false);
    openModal({
      isOpen: true,
      type: "confirmation",
      title: `로그아웃`,
      message: ["로그아웃하시겠습니까?"],
      handleConfirm: () => onClickModalCheck(),
      handleCancel: () => closeModal(),
    });
  };

  const onClickModalCheck = async () => {
    try {
      await userAuthLogout();
      closeModal();

      setTimeout(() => {
        navigate(`/shop${url ? `/${url}` : ""}/login`, { replace: true });
      }, 100);
    } catch (error) {
      console.error("로그아웃 처리 중 오류:", error);
      closeModal();
      navigate(`/shop${url ? `/${url}` : ""}/login`, { replace: true });
    }
  };

  const renderLayout = () => {
    if (!isMatch && ["0", "2"].includes(String(theme))) {
      const menuItem = ["mypage", "cart", "history"];

      return (
        <div className="inner">
          {user ? (
            <div>
              <button onClick={() => handleLogoutModal()}>로그아웃</button>
            </div>
          ) : (
            <div>
              <button onClick={() => navigate(`/shop${url ? `/${url}` : ""}/login`)}>로그인</button>
            </div>
          )}
          <div>
            <Logo
              logo={logo}
              handleHome={handleHome}
              homepageInfo={homepageInfo}
              cmpnyNm={cmpnyNm}
              theme={theme}
              isMatch={isMatch}
            />
            <Search setToggleSearch={setToggleSearch} setClickSideMenu={setClickSideMenu} />
            <ul>
              {menuItem.map((item) => (
                <li
                  onClick={() => {
                    const isRoot = item === "mypage";
                    const targetPath = isRoot ? "mypage" : `mypage/${item}`;
                    const statePath = isRoot ? "mypage" : `mypage/${item}${path || ""}`;

                    navigate(`/shop/${targetPath}`, {
                      state: { path: statePath },
                    });
                  }}>
                  <img src={`/img/shopTheme/icon/${item}.png`} alt={item} />
                </li>
              ))}
            </ul>
          </div>
          <div>
            <Category />
            <Gnb
              menus={menus}
              // links={links}
              url={url}
              theme={theme}
              isMatch={isMatch}
              homepageInfo={homepageInfo}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div className="inner">
          <Logo
            logo={logo}
            handleHome={handleHome}
            homepageInfo={homepageInfo}
            cmpnyNm={cmpnyNm}
            theme={theme}
            isMatch={isMatch}
          />
          <Gnb
            menus={menus}
            // links={links}
            url={url}
            theme={theme}
            isMatch={isMatch}
            homepageInfo={homepageInfo}
          />
          <Tnb
            handleLogoutModal={handleLogoutModal}
            url={url}
            homepageInfo={homepageInfo}
            setClickSideMenu={setClickSideMenu}
            theme={theme}
            isMatch={isMatch}
          />
        </div>
      );
    }
  };

  return (
    <>
      {modal}
      <HeaderContainer className={!isMatch ? `theme-${theme}` : ""}>
        {renderLayout()}
        {["0", "2"].includes(String(theme)) && (
          <SearchForm toggleSearch={toggleSearch} setToggleSearch={setToggleSearch} />
        )}
      </HeaderContainer>
      {!isMobile ? (
        <ShopSideMenu
          setClickSideMenu={setClickSideMenu}
          clickSideMenu={clickSideMenu}
          user={user}
          url={url}
          menus={menus}
          homepageInfo={homepageInfo}
        />
      ) : (
        <SlidingSideMenu
          homepageInfo={homepageInfo}
          handleLogoutModal={handleLogoutModal}
          setClickSideMenu={setClickSideMenu}
          clickSideMenu={clickSideMenu}
          url={url}
          menus={menus}
          theme={theme}
          isMatch={isMatch}
        />
      )}
    </>
  );
};

export default ShoppingHeader;
